import React, { useEffect, useState } from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import { formatDistanceStrict } from "date-fns";

import config from "../config/config";
import IconTouchable from "../components/IconTouchable";
import Icon from "../components/Icon";
import Screen from "../components/Screen";
import ListItem from "../components/lists/ListItem";
import { sendWhatsapp } from "../utility/contactUser";
import authApi from "../api/auth";
import useApi from "../hooks/useApi";
import usersApi from "../api/users";
import AppText from "../components/AppText";
import BlockSeperator from "../components/BlockSeperator";
import ListItemSwitch from "../components/lists/ListItemSwitch";
import Selector from "../components/Selector";

function UserDetailsScreen({ navigation, route }) {
    const [message, setMessage] = useState();

    const resetPasswordApi = useApi(authApi.resetPassword);
    const setUserEnabledApi = useApi(usersApi.setEnabled);
    const setUserVehicleNotificationsEnabledApi = useApi(usersApi.setVehicleNotificationsEnabled);
    const setUserPartRequestNotificationsEnabledApi = useApi(usersApi.setPartRequestNotificationsEnabled);
    const setUserInStockNotificationsEnabledApi = useApi(usersApi.setInStockNotificationsEnabled);
    const setUserAwaitingRemovalNotificationsEnabledApi = useApi(usersApi.setAwaitingRemovalNotificationsEnabled);
    const setUserAwaitingContactNotificationsEnabledApi = useApi(usersApi.setVehicleAwaitingContactNotificationsEnabled);
    const setTypeApi = useApi(usersApi.setType);
    const getUserApi = useApi(usersApi.getUser);
    const [user, setUser] = useState();

    useEffect(() => {
        getUser();
    }, []);

    const getUser = async () => {
        const response = await getUserApi.request(route.params._id);
        if (response.ok) {
            setUser(response.data);
        }
    };

    const setNewType = async (type) => {
        if (user.type == type) {
            return;
        }
        await setTypeApi.request(user._id, type);
    };

    const handlePasswordReset = async () => {
        console.log("here");
        const response = await resetPasswordApi.request(user.email);
        if (response.ok) {
            setMessage("Password Reset Email Sent");
        } else {
            setMessage("Password Reset Failed, please contact support");
        }
    };

    if (!user) {
        return null;
    }

    return (
        <Screen title={"User Details"} navigation={navigation} message={message} setMessage={setMessage}>
            <ScrollView>
                <ListItem title={user.name} subTitle={user.email} IconComponent={<Icon name="account" backgroundColor={config.colors.tertiary} />} />
                <ListItem
                    title={"Phone"}
                    subTitle={user.phone}
                    IconComponent={<Icon name="phone" backgroundColor={config.colors.tertiary} />}
                    utilityComponent={<IconTouchable name="whatsapp" onPress={() => sendWhatsapp(user)} />}
                />
                <BlockSeperator />
                <Selector
                    onChange={(selectedValue) => {
                        setNewType(selectedValue);
                    }}
                    title={"User Type"}
                    value1={"admin"}
                    textValue1={"Admin"}
                    icon1={"account-star"}
                    startingValue={user.type}
                />
                <BlockSeperator />
                <ListItem
                    title={"Last Login"}
                    IconComponent={<Icon name="lock-open" backgroundColor={config.colors.tertiary} />}
                    utilityComponent={
                        user.log.lastLogin && (
                            <AppText>
                                {formatDistanceStrict(new Date(user.log.lastLogin), new Date(), {
                                    addSuffix: true,
                                })}
                            </AppText>
                        )
                    }
                />
                <ListItem
                    title={"Device Info"}
                    subTitle={"Model Name"}
                    IconComponent={<Icon name="phone" backgroundColor={config.colors.tertiary} />}
                    utilityComponent={<AppText>{user.deviceInfo ? user.deviceInfo.modelName : "Unknown"}</AppText>}
                />
                <BlockSeperator />
                <ListItem
                    title={"Reset Password"}
                    subTitle={"Send Password Reset Email"}
                    utilityComponent={<IconTouchable name="lock-reset" iconColor={"red"} onPress={() => handlePasswordReset()} />}
                />
                <ListItemSwitch itemID={user._id} title={"Account Status"} value={user.enabled} onSwitch={setUserEnabledApi} />
            </ScrollView>
        </Screen>
    );
}

const styles = StyleSheet.create({
    userTypeSelector: {
        flexDirection: "row",
        backgroundColor: config.colors.white,
        paddingVertical: 20,
        justifyContent: "space-evenly",
    },
});

export default UserDetailsScreen;
